import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiDomain, mdiAccountTieOutline, mdiCheck } from "@mdi/js";
import { cn } from "@heroui/react";
import { contractorDetailStore } from "@/stores/ContractorDetailStore";

const StepTypeSelector: React.FC = observer(() => {
  const { legal } = contractorDetailStore;
  const { legalTypeSelected } = legal.drawer;

  return (
    <div className="scd-drawer-form">
      <p className="scd-legal-type__desc">
        Выберите юридический статус контрагента. От этого зависит состав
        необходимых документов.
      </p>
      <div className="scd-legal-type-grid">
        <button
          type="button"
          className={cn(
            "scd-legal-type-card",
            legalTypeSelected === "legal" && "scd-legal-type-card--selected",
          )}
          onClick={() => legal.selectLegalType("legal")}
        >
          <div className="scd-legal-type-card__icon">
            <Icon path={mdiDomain} size={1.2} />
          </div>
          <span className="scd-legal-type-card__title">Юридическое лицо</span>
          <span className="scd-legal-type-card__meta">ИП / ООО / АО</span>
          {legalTypeSelected === "legal" && (
            <span className="scd-legal-type-card__check">
              <Icon path={mdiCheck} size={0.7} />
            </span>
          )}
        </button>
        <button
          type="button"
          className={cn(
            "scd-legal-type-card",
            legalTypeSelected === "selfemployed" &&
              "scd-legal-type-card--selected",
          )}
          onClick={() => legal.selectLegalType("selfemployed")}
        >
          <div className="scd-legal-type-card__icon">
            <Icon path={mdiAccountTieOutline} size={1.2} />
          </div>
          <span className="scd-legal-type-card__title">Физическое лицо</span>
          <span className="scd-legal-type-card__meta">Самозанятый</span>
          {legalTypeSelected === "selfemployed" && (
            <span className="scd-legal-type-card__check">
              <Icon path={mdiCheck} size={0.7} />
            </span>
          )}
        </button>
      </div>
    </div>
  );
});

StepTypeSelector.displayName = "StepTypeSelector";
export default StepTypeSelector;
